var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAnimationCall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#40B359"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 2,
    height: 16,
    rx: 1,
    fill: "#40B359"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#40B359"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAnimationCall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-animation-call.5e15e02f6b547988696a9145206cd327.svg";